import {
  Typography,
  TableSortLabel,
  TableHead,
  TableRow,
  TableCell,
  Tooltip,
} from "@material-ui/core";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { useStyles } from "./styles";

interface PropsType {
  tableHeadersList: any;
  sortAction: (data: any) => (dispatch: Dispatch) => void;
  pagginationAction: (data: number) => (dispatch: Dispatch) => void;
  filters: any;
}

export const TableSortHead: FC<PropsType> = ({
  tableHeadersList,
  pagginationAction,
  sortAction,
  filters,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [sortId, setSortId] = useState<string | undefined>(filters?.ordering || "-week_number");

  const handleSortChange = (sortId: string | undefined, cellId: string) => {
    if (filters.pageNumber > 0) dispatch(pagginationAction(0));
    if (sortId?.replace("-", "") === cellId) {
      const sortString = `${sortId?.includes("-") ? "" : "-"}${cellId}`;
      setSortId(sortString);
      dispatch(sortAction({ordering: sortString}));
    } else {
      setSortId(cellId);
      dispatch(sortAction({ordering: cellId}));
    }
  };

  return (
    <TableHead data-testid="testSortTableHead">
      <TableRow>
        {tableHeadersList.map((el: any | any) => (
          <TableCell
            data-testid={`sortTableHeadColumn-${el.id}`}
            key={el.label}
            colSpan={1}
            className={`${classes.tableHeadCell} ${classes.tableHeadWhiteCell}`}
          >
            <TableSortLabel
              disabled={!el.hasSortLabel}
              active={sortId?.replace("-", "") === el.id}
              direction={
                sortId?.replace("-", "") === el.id && sortId?.includes("-") ? "desc" : "asc"
              }
              onClick={() => handleSortChange(sortId, el.id)}
            >
              {el?.toolTipLabel ? (
                <Tooltip title={<Typography>{el.toolTipLabel}</Typography>}>
                  <Typography className={classes.tableHeadTypography}>{el.label}</Typography>
                </Tooltip>
              ) : (
                <Typography className={classes.tableHeadTypography}>{el.label}</Typography>
              )}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
